import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    background: white;
    padding: 2.5rem 3rem;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    min-width: 320px;
    max-width: 90vw;
    margin-top: 2rem;
    margin-bottom: 5rem;
    text-align: center;
`

export const Title = styled.h2`
    margin-bottom: 1rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #222;
`

export const Message = styled.p`
    margin-bottom: 2rem;
    font-size: 1.1rem;
    color: #555;
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 1rem;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: stretch;
    }
`
